export default "__VITE_ASSET__BerHuphi__"